<template>
    <div class="step-box">
        <div class="step-head">Step 2. Fill In Personal Information</div>
        <div class="step-body">
            <div class="tip">Please fill in the information below in English</div>
            <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item label="Name of Contestant:" prop="realName">
                    <a-input v-model="form.realName" placeholder="Please fill in the full name of the contestant" />
                </a-form-model-item>
                <a-form-model-item label="Date of Birth" prop="birthday">
                    <a-date-picker v-model="form.birthday" :format="dateFormat" style="width: 100%" placeholder="Select the birthday of the contestant"/>
                </a-form-model-item>
                <a-form-model-item label="Country" prop="address">
                    <a-cascader v-model="form.address" :options="areaData" :fieldNames="fieldName" placeholder="Select the country or region"></a-cascader>
                </a-form-model-item>
                <a-form-model-item label="Organization" prop="organizationName">
                    <a-input v-model="form.organizationName" placeholder="Please fill in the full name of the school or organization" />
                </a-form-model-item>
                <a-form-model-item label="Name of Mentor" prop="teacherName">
                    <a-input v-model="form.teacherName" placeholder="Please fill in the full name of the mentor" />
                </a-form-model-item>
                <a-form-model-item label="E-mail" prop="email">
                    <a-input v-model="form.email" placeholder="Please fill in the valid email" />
                </a-form-model-item>
            </a-form-model>
            <div class="op-box">
                <a href="javascript:" class="btn secondary" @click="prev()">Back</a>
                <a href="javascript:" class="btn primary" @click="submitInformation">Next</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormModel, Input, DatePicker, Cascader} from 'ant-design-vue'
    import moment from 'moment'
    import areaData from '../../assets/json/area_en.json'

    export default {
        name: "information",
        components: {
            AFormModel: FormModel,
            AFormModelItem: FormModel.Item,
            AInput: Input,
            ADatePicker: DatePicker,
            ACascader: Cascader,
        },
        props: {
            prev: Function,
            userInformation: Object,
        },
        created() {
            this.init()
        },
        data() {
            return {
                dateFormat: 'YYYY-MM-DD',
                labelCol: { span: 6 },
                wrapperCol: { span: 14 },
                form: {
                    realName: '',
                    birthday: undefined,
                    email: '',
                    address: undefined,
                    organizationName: '',
                    teacherName: '',
                },
                rules: {
                    realName: [
                        {required: true, message: 'Name of Contestant is required.'},
                        {min:1, max: 128, message: 'The number of characters exceeds the limit.'},
                    ],
                    birthday: [
                        {required: true, message: 'Date of Birth is required.'}
                    ],
                    address: [
                        {required: true, message: 'Country is required.'}
                    ],
                    organizationName: [
                        {required: true, message: 'Organization is required.'},
                        {min:1, max: 128, message: 'The number of characters exceeds the limit.'},
                    ],
                    teacherName: [
                        {required: true, message: 'Name of Mentor is required.'},
                        {min:1, max: 128, message: 'The number of characters exceeds the limit.'},
                    ],
                    email: [
                        {required: true, message: 'E-mail is required.'},
                        {min:1, max: 128, message: 'The number of characters exceeds the limit.'},
                        {pattern: '[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z0-9]{2,6}$', message: 'Please enter the correct email address.'}
                    ]
                },
                areaData,
                fieldName: {
                    label: 'ename',
                    value: 'ename',
                    children: 'children'
                },
            }
        },
        methods: {
            moment,
            init() {
                if(this.userInformation) {
                    this.form = this.userInformation
                }
            },
            submitInformation() {
                this.$refs['form'].validate(valid => {
                    if(valid) {
                        this.$emit('getUserInformation', this.form)
                    } else {
                        return false
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .tip {
        font-size: 16px;
        margin-bottom: 25px;
    }
</style>
